<template>
  <router-view v-slot="{ Component, route }" id="routerViewStyle">
      <transition :name="route.meta.transition || 'slide'">
      <component :is="Component"/>
    </transition>
  </router-view>
</template>

<style>
@import url("https://p.typekit.net/p.css?s=1&k=jjy2rhw&ht=tk&f=35361.35362.35363.35364.35365.35366.35367.35368.35369.35370.35371.35381.35382.35385.35386&a=202431493&app=typekit&e=css");

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/9f0109/00000000000000007758751a/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n2&v=3") format("woff2"),url("https://use.typekit.net/af/9f0109/00000000000000007758751a/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n2&v=3") format("woff"),url("https://use.typekit.net/af/9f0109/00000000000000007758751a/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n2&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:200;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/c30a8e/00000000000000007758751b/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i2&v=3") format("woff2"),url("https://use.typekit.net/af/c30a8e/00000000000000007758751b/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i2&v=3") format("woff"),url("https://use.typekit.net/af/c30a8e/00000000000000007758751b/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i2&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:200;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/0f7d56/00000000000000007758751d/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i3&v=3") format("woff2"),url("https://use.typekit.net/af/0f7d56/00000000000000007758751d/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i3&v=3") format("woff"),url("https://use.typekit.net/af/0f7d56/00000000000000007758751d/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i3&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/bda536/00000000000000007758751c/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n3&v=3") format("woff2"),url("https://use.typekit.net/af/bda536/00000000000000007758751c/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n3&v=3") format("woff"),url("https://use.typekit.net/af/bda536/00000000000000007758751c/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n3&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/61b077/00000000000000007758751f/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i4&v=3") format("woff2"),url("https://use.typekit.net/af/61b077/00000000000000007758751f/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i4&v=3") format("woff"),url("https://use.typekit.net/af/61b077/00000000000000007758751f/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i4&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:400;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/0bb693/00000000000000007758751e/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/0bb693/00000000000000007758751e/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/0bb693/00000000000000007758751e/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n4&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:400;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/1fc3c0/000000000000000077587521/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/1fc3c0/000000000000000077587521/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/1fc3c0/000000000000000077587521/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/215b84/000000000000000077587520/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/215b84/000000000000000077587520/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/215b84/000000000000000077587520/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/1d0ab4/000000000000000077587522/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/1d0ab4/000000000000000077587522/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/1d0ab4/000000000000000077587522/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/c62422/000000000000000077587523/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/c62422/000000000000000077587523/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/c62422/000000000000000077587523/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"brother-1816";
src:url("https://use.typekit.net/af/03fb61/000000000000000077587524/30/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i8&v=3") format("woff2"),url("https://use.typekit.net/af/03fb61/000000000000000077587524/30/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i8&v=3") format("woff"),url("https://use.typekit.net/af/03fb61/000000000000000077587524/30/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i8&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:800;font-stretch:normal;
}

.tk-brother-1816 { font-family: "brother-1816",sans-serif; }

body {
  margin: 0;
}

.brother {
  font-family: "brother-1816";
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-out;
}
.slide-enter-to {
  position: absolute;
  right: 0;
}
.slide-enter-from {
  position: absolute;
  right: -100%;
}
.slide-leave-to {
  position: absolute;
  left: -100%;
}
.slide-leave-from {
  position: absolute;
  left: 0;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.3s ease-out;
}
.slide-left-enter-to {
  position: absolute;
  left: 0;
}
.slide-left-enter-from {
  position: absolute;
  left: -100%;
}
.slide-left-leave-to {
  position: absolute;
  right: -100%;
}
.slide-left-leave-from {
  position: absolute;
  right: 0;
}

#routerViewStyle {
  position: absolute;
  height: 100vh;
  width: 100vw;
  top: 0px;
  /*overflow: hidden;*/
}
</style>

<script>
export default {
  data: function () {
  return {
  }
},
head: {
  title: {
    inner: 'treasurepeninsula',
    separator: '|',
    complement: '2025'
  },
  meta: [
    { name: 'title', content: 'treasurepeninsula2025'},
    { name: 'description', content: 'Seoul National University Metalwork' },
    { name: 'viewport', content: 'width=device-width,initial-scale=1.0,user-scalable=no' },
    { charset: 'utf-8' },
    { property: 'og:type', content: 'website' },
    { property: 'og:image', content: 'https://i.ibb.co/Zps082Sx/opengraph.jpg'},
    { property: 'og:title', content: 'treasurepeninsula2025'},
    { property: 'og:description', content: 'Seoul National University Metalwork' }
  ],
},
}
</script>